var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4008 11.5373C16.5323 11.5373 19.0709 9.02895 19.0709 5.93469C19.0709 2.84043 16.5323 0.332031 13.4008 0.332031C11.9974 0.332031 10.713 0.835817 9.72294 1.67035C8.73283 0.835826 7.44852 0.332046 6.04513 0.332046C2.9136 0.332046 0.375 2.84044 0.375 5.9347C0.375 9.02896 2.9136 11.5374 6.04513 11.5374C7.44853 11.5374 8.73284 11.0336 9.72295 10.199C10.7131 11.0336 11.9974 11.5373 13.4008 11.5373Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72266 10.1989C10.9418 9.17123 11.7148 7.64216 11.7148 5.93469C11.7148 4.22722 10.9418 2.69814 9.72266 1.67051C10.7128 0.835883 11.9972 0.332031 13.4007 0.332031C16.5322 0.332031 19.0708 2.84043 19.0708 5.93469C19.0708 9.02895 16.5322 11.5373 13.4007 11.5373C11.9972 11.5373 10.7128 11.0335 9.72266 10.1989Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72276 10.1991C10.942 9.17143 11.7151 7.64229 11.7151 5.93474C11.7151 4.22718 10.942 2.69804 9.72276 1.67041C8.50356 2.69804 7.73047 4.22718 7.73047 5.93474C7.73047 7.64229 8.50356 9.17143 9.72276 10.1991Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/_Mastercard.f5f524f73d7c0f1abea5a62cd7c821f8.svg";
export { ForwardRef as ReactComponent };